import { render, staticRenderFns } from "./ApprovedInvestmentRequests.vue?vue&type=template&id=1bb5e81d&"
import script from "./ApprovedInvestmentRequests.vue?vue&type=script&lang=js&"
export * from "./ApprovedInvestmentRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports